export function formatProcessDateInput(value) {
  const digits = String(value || '').replace(/\D/g, '').slice(0, 8)
  if (digits.length <= 2) return digits
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`
}

export function formatStoredProcessDate(value) {
  if (!value) return ''
  const text = String(value)
  const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(text)
  if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`
  return formatProcessDateInput(text)
}

export function isCompleteProcessDate(value) {
  return /^\d{2}\/\d{2}\/\d{4}$/.test(String(value || ''))
}
